// extracted by mini-css-extract-plugin
export default {"imageModalContent":"image-modal-content__WYTa90ub","modalImage":"modal-image__ElvIOxDF"};